// What build this is, and how to say so.
//
// The three constants below are computed once by `vite.config.ts` and baked into the
// bundle through `define` — a static bundle has no "live" to re-read them from, unlike
// the server, which reads its own environment name at every startup. `vite.config.ts`
// has the reasoning for each of the three; this file only reads what it wrote.
//
// The `declare const` trio names identifiers that exist only as a build-time text
// substitution: wherever `__MOR_BUILD_NUMBER__` (and the other two) appear in code that
// goes through `vite build` or `vite dev`, Vite's `define` replaces the bare identifier
// with a literal before anything runs — there is no global to look up at runtime.
// `vitest.config.ts` sets no `define`, so under the test suite these names are never
// substituted and stay undeclared identifiers. Referencing one directly would throw
// `ReferenceError`; `typeof` never throws on an identifier that was never declared, which
// is what lets this module — and everything that imports it — be exercised without a
// build having run first.

declare const __MOR_BUILD_NUMBER__: number | null;
declare const __MOR_BUILD_COMMIT__: string | null;
declare const __MOR_BUILD_ENVIRONMENT__: string | null;

/** The repository's `BUILD_NUMBER` at the moment this bundle was built, or `null`. */
export const BUILD_NUMBER: number | null =
  typeof __MOR_BUILD_NUMBER__ === 'undefined' ? null : __MOR_BUILD_NUMBER__;

/** The commit this bundle was built from, or `null` if it could not be determined. */
export const COMMIT: string | null =
  typeof __MOR_BUILD_COMMIT__ === 'undefined' ? null : __MOR_BUILD_COMMIT__;

/** `RAILWAY_ENVIRONMENT_NAME` at build time, or `null` outside a Railway build. */
export const ENVIRONMENT: string | null =
  typeof __MOR_BUILD_ENVIRONMENT__ === 'undefined' ? null : __MOR_BUILD_ENVIRONMENT__;

const PRODUCTION_ENVIRONMENT = 'production';

export type BuildIdentity = {
  environment: string | null;
  build: number | null;
  commit: string | null;
};

/**
 * What the account menu shows at its foot: `Build 32` in production, since the number and
 * the `prod-32` tag agree there and it is the fact a person can act on. The short commit everywhere
 * else, because a non-production build's number is, by construction, whatever the last
 * release into `main` happened to leave behind — it names no deploy in particular there,
 * but the commit always does. `null` when the fact that environment calls for is not
 * known, so a caller renders nothing rather than a string that would be lying about
 * being complete.
 *
 * Never both: which one applies is decided by the environment alone, not by whichever
 * value happens to be present.
 */
export function buildLabel({ environment, build, commit }: BuildIdentity): string | null {
  if (environment === PRODUCTION_ENVIRONMENT) {
    return build === null ? null : `Build ${build}`;
  }
  return commit === null ? null : commit.slice(0, 7);
}
